"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitiateCheckoutCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class InitiateCheckoutCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackInitiateCheckoutEvent(this.input);
    }
}
exports.InitiateCheckoutCommand = InitiateCheckoutCommand;
